import { NavLink, Outlet } from "react-router-dom";
import { Box, styled, Typography } from "@mui/material";

const TabsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.divider,
  borderRadius: 999,
  padding: 4,
  width: "fit-content",
  gap: 2,
  marginBottom: theme.spacing(3),
}));

const TabLink = styled(NavLink)(({ theme }) => ({
  padding: "5px 20px",
  borderRadius: 999,
  fontSize: "0.875rem",
  fontWeight: 500,
  textDecoration: "none",
  color: theme.palette.text.secondary,
  transition: "all 150ms ease",
  whiteSpace: "nowrap",

  "&:hover": {
    color: theme.palette.text.primary,
  },

  "&.active": {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
}));

const tabs = [
  { name: "Routing Profiles", path: "profiles" },
  { name: "Configuration", path: "config" },
];

const TransactionRoutingOutlet = () => {
  return (
    <Box sx={{ m: 2 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" fontWeight={600}>
          Transaction Routing
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Control how transactions are directed to different payment providers
          and channels
        </Typography>
      </Box>

      <TabsWrapper>
        {tabs.map((tab) => (
          <TabLink key={tab.path} to={`/tech/transaction-routing/${tab.path}`}>
            {tab.name}
          </TabLink>
        ))}
      </TabsWrapper>

      <Outlet />
    </Box>
  );
};

export default TransactionRoutingOutlet;
